export enum ComponentName {
  OpnBoardMembersList,
  OpnOfferEvaluationMember
}
